import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { sharedStyles } from '../../../utils/Style';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';

export const ParamPosSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.PARAM_POS)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(SettingsType.PARAM_POS, key, settings, newValue),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings)
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Paper
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '95%',
      }}
    >
      <Waiting open={loading} />
      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Param Pos
      </Typography>
      <Divider />

      <SettingsRow
        name='Aktif'
        valueType={SettingsValueType.BOOLEAN}
        value={getSettingsValue(settings, 'param_enabled')}
        onChange={(newValue) => handleChange('param_enabled', newValue)}
      />
      <SettingsRow
        name='Başlık'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'param_label')}
        onChange={(newValue) => handleChange('param_label', newValue)}
      />
      <SettingsRow
        name='Açıklama'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'param_description')}
        onChange={(newValue) => handleChange('param_description', newValue)}
        multiline
      />
      <SettingsRow
        name='URL'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'param_url')}
        onChange={(newValue) => handleChange('param_url', newValue)}
      />
      <SettingsRow
        name='CLIENT_USERNAME'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'param_client_username')}
        onChange={(newValue) => handleChange('param_client_username', newValue)}
      />
      <SettingsRow
        name='CLIENT_CODE'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'param_client_code')}
        onChange={(newValue) => handleChange('param_client_code', newValue)}
      />
      <SettingsRow
        name='CLIENT_PASSWORD'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'param_client_password')}
        onChange={(newValue) => handleChange('param_client_password', newValue)}
        masked
      />
      <SettingsRow
        name='GUID'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'param_guid')}
        onChange={(newValue) => handleChange('param_guid', newValue)}
      />

      <Box sx={{ display: 'flex', flexGrow: 1 }} />
      <Box display='flex' justifyContent='flex-end'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
